import {
  Route,
  Routes,
  Outlet,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import helpdeskStyles from '../aiHelpDesk/AiHelpDesk.module.scss';
import styles from './aiAutomation.module.scss';
import {SkillsManagement} from './SkillsManagement';
import {SkillTranslations} from './SkillTranslations';
import {FlowBuilder} from './flowBuilder/FlowBuilder';
import {ContentTransformations} from './contentTransformations/ContentTransformations';
import {CONTENT_TRANSFORMATION_PATH} from './contentTransformations/constants';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const AI_AUTOMATION_SUBTABS = [
  {key: 'skills', label: 'Skills', to: '/dashboard/ai-automation/skills'},
  {
    key: 'flow-builder',
    label: 'Flow Builder',
    to: '/dashboard/ai-automation/flow-builder',
  },
];

/*
 * Content transformations is its own tab but shares the `flow-builder`
 * permission scope on the backend, so it is not part of the catalog above —
 * it rides along whenever Flow Builder itself is visible.
 */
const CONTENT_TRANSFORMATIONS_SUBTAB = {
  key: 'content-transformations',
  label: 'Content Transformations',
  to: CONTENT_TRANSFORMATION_PATH,
};

const AiAutomationComponentsPage = () => (
  <div className={styles.panel}>
    <p className={styles.muted}>Configure automation components here.</p>
  </div>
);

const AiAutomationLayout = () => {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const activeMain = pathname.includes('/manual-content-transformations')
    ? 'content-transformations'
    : pathname.includes('/flow-builder')
    ? 'flow-builder'
    : pathname.endsWith('/components')
    ? 'components'
    : 'skills';

  const {visibleSubTabs, isVisible} = useVisibleSubTabs(
    NavTabsEnum.AiAutomationTab,
    AI_AUTOMATION_SUBTABS,
  );

  const subTabs = isVisible('flow-builder')
    ? [...visibleSubTabs, CONTENT_TRANSFORMATIONS_SUBTAB]
    : visibleSubTabs;

  return (
    <div className={helpdeskStyles.container}>
      <div className={helpdeskStyles.header}>
        <h1>AI & Automation</h1>
      </div>

      <div className={helpdeskStyles.mainTabsContainer}>
        {subTabs.map(tab => (
          <div
            key={tab.key}
            className={`${helpdeskStyles.mainTab} ${
              activeMain === tab.key ? helpdeskStyles.activeMainTab : ''
            }`}
            onClick={() => navigate(tab.to)}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate(tab.to);
              }
            }}>
            {tab.label}
          </div>
        ))}
      </div>

      <Outlet />
    </div>
  );
};

export const AiAutomationRoutes = () => {
  return (
    <Routes>
      <Route element={<AiAutomationLayout />}>
        <Route index element={<Navigate to="skills" replace />} />
        <Route path="skills" element={<SkillsManagement />} />
        <Route
          path="skills/:skillId/translations"
          element={<SkillTranslations />}
        />
        <Route path="flow-builder" element={<FlowBuilder />} />
        <Route
          path="flow-builder/manual-content-transformations"
          element={<ContentTransformations />}
        />
        <Route path="components" element={<AiAutomationComponentsPage />} />
      </Route>
    </Routes>
  );
};
